import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {DocumentListParams, EQDocument} from "../../models/serverModels/workOrder/EQDocument";

const rootApi = process.env.REACT_APP_API_KEY;

const document = axios.create({
  baseURL: rootApi,
});

export const getList = async (params: DocumentListParams): Promise<ResponseList<EQDocument>> =>
  document({
    url: `/DocumentList/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EQDocument>> =>
  document({
    url: `/Document/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);
export const create = async (
  params: Params.Create<EQDocument>
): Promise<ResponseItem<EQDocument>> =>
  document({
    url: `/Document`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  document({
    url: `/Document/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<EQDocument>
): Promise<ResponseItem<EQDocument>> =>
  document({
    url: `/Document/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
